import { Button, Icon } from "semantic-ui-react";

import { getAppointmentStatus } from "components";
import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import "components/StatusFilters/StatusFilters.scss";
import { STATUS_IDENTIFIERS } from "models";

export type StatusFilter = {
  icon: string;
  identifier: STATUS_IDENTIFIERS;
  isActive: boolean;
};

export const statusFilters: StatusFilter[] = [
  { icon: "car mirrors", isActive: true, identifier: STATUS_IDENTIFIERS.NewCarStatus },
  { icon: "calendar check", isActive: true, identifier: STATUS_IDENTIFIERS.HandleCheckIn },
  { icon: "car garage", isActive: true, identifier: STATUS_IDENTIFIERS.CarInShop },
  { icon: "circle quarter stroke", isActive: true, identifier: STATUS_IDENTIFIERS.CarCheckStartedStatus },
  { icon: "square a", isActive: true, identifier: STATUS_IDENTIFIERS.AannameOKStatus },
  { icon: "wrench", isActive: true, identifier: STATUS_IDENTIFIERS.CarCheckStatus },
  { icon: "dollar", isActive: true, identifier: STATUS_IDENTIFIERS.CalculatingStatus },
  { icon: "tag", isActive: true, identifier: STATUS_IDENTIFIERS.PricingOKStatus },
  { icon: "icon phone volume", isActive: true, identifier: STATUS_IDENTIFIERS.ContactStatus },
  { icon: "user check", isActive: true, identifier: STATUS_IDENTIFIERS.CustomerAnsweredStatus },
  { icon: "face smile regular", isActive: true, identifier: STATUS_IDENTIFIERS.CustomerOKStatus },
  { icon: "triangle exclamation", isActive: true, identifier: STATUS_IDENTIFIERS.DiagnoseStatus },
  { icon: "bo", isActive: true, identifier: STATUS_IDENTIFIERS.BackOrder },
  { icon: "check double", isActive: true, identifier: STATUS_IDENTIFIERS.CarReadyStatus },
  { icon: "shield check", isActive: true, identifier: STATUS_IDENTIFIERS.QualityCheckStatus },
  { icon: "right from bracket outOfShop", isActive: true, identifier: STATUS_IDENTIFIERS.CarOutOfShop },
  { icon: "circle xmark", isActive: true, identifier: STATUS_IDENTIFIERS.CanceledStatus }
];

type StatusFiltersProps = {
  filters?: StatusFilter[];
  onChange: (filter: StatusFilter[]) => void;
};

export const StatusFilters = ({ onChange, filters = statusFilters }: StatusFiltersProps) => {
  const { selectedLocation } = useSelectedLocation();

  const handleClick = (identifier: number) => {
    const filterIdx = filters.findIndex(f => f.identifier === identifier);
    if (filterIdx < 0) return;

    onChange(filters.with(filterIdx, { ...filters[filterIdx], isActive: !filters[filterIdx].isActive }));
  };

  if (!selectedLocation?.statuses) return null;

  return (
    <div className="status-filters-wrapper">
      {filters.map(item => {
        return (
          <div key={item.identifier} className="StatusFilters-buttons" onClick={() => handleClick(item.identifier)}>
            <Button
              color="orange"
              className="af"
              style={{ backgroundColor: getAppointmentStatus(item.identifier, selectedLocation.statuses).color }}
              disabled={!item.isActive}
            >
              {item.icon === "bo" ? "BO" : <Icon className={item.icon} />}
            </Button>
          </div>
        );
      })}
    </div>
  );
};
